import React from "react";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";

import LockIcon from "@material-ui/icons/Lock";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

import { Button, Typography } from "@material-ui/core";

import SvgI24Details from "assets/icons/I24Details";
import SvgI24Menu from "assets/icons/I24Menu";

import PublishStatus from "components/PublishStatus";
import TrimmedText from "components/TrimmedText";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
  MenuContent,
  MenuContentWrapper,
  Menu,
  IconGap,
} from "./styles";

type Props = {
  title: string;
  duration: string;
  image: string;
  publishStatus: string;
  onDetailsClick: () => void;
  onRemove: () => void;
  onAccessClick?: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  isDragging?: boolean;
};

class CategoryDetailsCard extends React.Component<Props> {
  render() {
    const {
      title,
      duration,
      image,
      publishStatus,
      onAccessClick,
      onDetailsClick,
      onRemove,
      dragHandleProps,
      isDragging,
    } = this.props;

    return (
      <Container isDragging={isDragging}>
        <ImageContainer image={image} />
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h3" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
            <Typography variant="subtitle1" color="secondary">
              {duration}
            </Typography>
          </TextContainer>
          <BottomControlsContainer>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Details />}
                variant="text"
                color="secondary"
                onClick={onDetailsClick}
              >
                Details
              </Button>
            </ControlWrapper>
            {onAccessClick && (
              <ControlWrapper>
                <Button
                  startIcon={<LockIcon />}
                  variant="text"
                  color="secondary"
                  onClick={onAccessClick}
                >
                  Access
                </Button>
              </ControlWrapper>
            )}
            <ControlWrapper>
              <Button
                startIcon={<RemoveCircleOutlineIcon />}
                variant="text"
                color="secondary"
                onClick={onRemove}
              >
                Remove
              </Button>
            </ControlWrapper>
          </BottomControlsContainer>
        </DetailsContainer>

        <MenuContent>
          <MenuContentWrapper>
            <PublishStatus status={publishStatus} />
          </MenuContentWrapper>

          <MenuContentWrapper>
            {dragHandleProps ? (
              <Menu {...dragHandleProps}>
                <SvgI24Menu />
              </Menu>
            ) : (
              <IconGap />
            )}
          </MenuContentWrapper>
        </MenuContent>
      </Container>
    );
  }
}

export default CategoryDetailsCard;
